/* eslint-disable no-unused-vars */
import React from "react";
import {t} from "../../../../dev/helpers/translator";
import KeyboardInput from "../InputKeyboard";
import CountDownComponent from "../countDownClock";

export default function ticketInManualCheckTemplate () {
    return (
        <div className="ticketin-popup">
            <CountDownComponent second={60}/>
            <div className="popup-contain-table-m login-form-m">
                <div className="center-view-contain-form">
                    <div className="mini-logo-view">
                        <div className="mini-logo-container"/>
                        <p className="admin-title">{t(`Enter ticket`)}</p>
                    </div>
                    <div className="form-contain-box">
                        <div className="single-form-item">
                            <KeyboardInput type='text' placeholder={t(`Barcode`)} onChange={this.onChange}/>
                        </div>
                        <div className="separator-box-buttons-m admin-login-button">
                            <button className="button-view-normal-m" onClick={this.confirmBarcode} disabled={!this.state.barcode}>{t("Confirm")}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}